import serverCall from "../../serverCall";

const createImage = async (data) => {
    const response = await serverCall.post(
        `/images/admin/add-image`, data
    );
    return response;
};

const AddImageService = {
    createImage,
};

export default AddImageService;
